import { ElecRates } from "@soenergy/frontend-library/src/constants/tariff"
import { RenewalQuote } from "@/models/RenewalQuote"

export const EV_SMART_TARIFF_NAME = "So EV Connected"

// Mirrors be-products' EV_OFF_PEAK_USAGE_PERCENT so the estimate reconciles with the base quote
export const EV_SMART_OFF_PEAK_USAGE_SHARE = 0.43
const EV_SMART_OFF_PEAK_DISCOUNT_IN_PENCE = 1
export const EV_SMART_PLACEHOLDER_PRODUCT_CODE = "PLACEHOLDER-EVSMART"

const discountedRateInPence = (costPerKwhInPence: number): number =>
  Math.max(
    0,
    Math.round(
      (costPerKwhInPence - EV_SMART_OFF_PEAK_DISCOUNT_IN_PENCE) * 100
    ) / 100
  )

export const buildEvSmartQuote = (
  base?: RenewalQuote | null
): RenewalQuote | null => {
  // Without an off-peak rate the advertised saving would have no mechanism behind it
  if (!base?.evOffPeakRate) return null

  const offPeakUsageInKwh =
    base.annualElecUsageInKwh * EV_SMART_OFF_PEAK_USAGE_SHARE

  if (offPeakUsageInKwh <= 0) return null

  const savingInPounds =
    (offPeakUsageInKwh * EV_SMART_OFF_PEAK_DISCOUNT_IN_PENCE) / 100
  const costPerYearInPounds = base.costPerYearInPounds - savingInPounds

  if (costPerYearInPounds <= 0) return null

  const elecRates = base.elecRates?.map((rate) =>
    rate.name === ElecRates.EvOffPeak
      ? {
          ...rate,
          costPerKwhInPence: discountedRateInPence(rate.costPerKwhInPence),
        }
      : { ...rate }
  )

  const overrides: Partial<RenewalQuote> = {
    tariffName: EV_SMART_TARIFF_NAME,
    shortTariffName: EV_SMART_TARIFF_NAME,
    isRecommended: false,
    costPerYearInPounds,
    costPerMonthInPounds: costPerYearInPounds / 12,
    elecProductCode: EV_SMART_PLACEHOLDER_PRODUCT_CODE,
    elecRates,
  }

  return base.cloneWith(overrides)
}
